import axios, { AxiosResponse } from 'axios';
import * as _ from 'underscore';
import { camelizeKeys } from 'xcase';

import { ErrorHandler } from './ResponseHandler';

// NOTE: Rather than using this requests.ts import the localAxios module.

// TODO-FUTURE: Replace uses of request with localAxios
export const get = async <T>(endpointURL, options = null) => {
  options = {
    convertCase: false,
    ...options,
  };

  const requestOptions = _.extend(
    {
      method: 'get',
      url: endpointURL,
      withCredentials: true,
    },
    options
  );

  return new Promise<AxiosResponse<T>>((resolve, reject) => {
    axios(requestOptions)
      .then((response) => {
        if (response.data) {
          if (options.convertCase) {
            response.data = camelizeKeys(response.data);
          }
        }
        resolve(response);
      })
      .catch((error) => {
        reject(ErrorHandler(error));
      });
  });
};
